import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import preCloserissustration from "../../../../../Images/NewUI/preclosemoney.png";
import { loanStatusApi, notifyVisitorEvent } from "../../../../../Redux/ApplyLoan/action";

const OfferCard = (props) => {
    const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    const [loader, setLoader] = useState(false);
    const [preForcloserAmount, setPreForcloserAmount] = useState("");
    const [saveForcluserAmount, setSaveForcluserAmount] = useState("");
    
    
    
    const handleGetLoanData = () => {
        let data = {};
        setLoader(true);
        props
          .loanStatusApi(data, token)
          .then((res) => {
            setLoader(false);
            
           
            if (res.status === 200) {
                setPreForcloserAmount(res?.data?.data[0]?.preclosure_amount?.toLocaleString('en-IN'));

                setSaveForcluserAmount(res?.data?.data[0]?.preclosure_save_amount?.toLocaleString('en-IN'))
            }
          })
          .catch((err) => {
            setLoader(false);
            if (err.response?.status === 401) {
              window.location.href = "/";
              localStorage.removeItem("gpay_token");
            }
            let error = err?.response?.data?.error;
    
            ToastMsg(error, "error");
            // console.log(err);
          });
      };
      useEffect(() => {
        handleGetLoanData();
      }, []);
      const handleRedirect = () => {



        const payload = {
          event_name: "Interacted_SuperApp_Dashboard",
          event_body: {
            "Platform": "m-site",
            "Clicked on": "Foreclosure_6_EMI",
          },
        };
        
        notifyVisitorEvent(payload)
          .then((response) => {
            console.log("NotifyVisitor Event Sent:", response);
          })
          .catch((error) => {
            console.error("Error sending NotifyVisitor event:", error);
          });

     
        const fromValue = "preclosure";
window.location.href = `/loan_repay?from=${encodeURIComponent(fromValue)}`;
    };
  return (

    <div className="offer-card">
      <div className="offer-details">
        {/* <p className="offer-title">Limited Time Offer!</p> */}
        <span className="offer-price">
          For just <span className="rupeesignnew">₹</span>{preForcloserAmount} 
        </span>
        <span className="offer-price-sub">Foreclose and save ₹{saveForcluserAmount}</span>
        <div onClick={handleRedirect} className="foreclose-button">Foreclose Now »</div>
      </div>
      <div className="illustration">
      <img
        src={preCloserissustration} 
         alt="Illustration"
       />
    </div>
    </div>

  );
};


const mapStateToProps = (state) => {
    return {
      user: state.user,
      userDetail: state.userDetail,
    };
  };
  export default connect(mapStateToProps, {
    loanStatusApi,
    notifyVisitorEvent,
  })(OfferCard);